import { User } from 'src/app/shared/models/user';
import { AuthService } from './../../core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrl: './auth.component.scss'
})
export class AuthComponent implements OnInit {
    user: User;

    constructor(
        private authService: AuthService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.authorize();
    }

    private authorize() {
        // const code = this.route.snapshot.queryParamMap.get('code');
        // this.authService.authorize(code).subscribe((user: User) => {
        //     this.user = user;
        // });
    }
}
